<h1 mat-dialog-title>Connection settings -
  <span *ngIf="telephoneNumber.value!=null && telephoneNumber.value !=''">{{telephoneNumber.value}}</span>
  <span *ngIf="internalNumber.value!=null && internalNumber.value !='' && (telephoneNumber.value==null || telephoneNumber.value =='')">{{internalNumber.value}}</span>
  </h1>

<div mat-dialog-content>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-sm-6">
        <mat-form-field class="full-width">
          <mat-label>Select provider</mat-label>
          <mat-select formControlName="provider">
            <mat-option *ngFor="let item of providers" [value]="item.id">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field class="w-100">
          <mat-label>Internal telephone number</mat-label>
          <input matInput formControlName="internalNumber">
          <mat-error *ngIf="internalNumber.invalid && internalNumber.touched">
            Number is required!
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="isUserBaseAuth == true">
      <div class="col-sm-6">
        <mat-form-field class="w-100">
          <mat-label>User</mat-label>
          <input matInput formControlName="user">
          <mat-error *ngIf="user.invalid && user.touched">
            User is required!
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field class="w-100">
          <mat-label>Auth user</mat-label>
          <input matInput formControlName="authUser">
          <mat-error *ngIf="authUser.invalid && authUser.touched">
            Auth user is required!
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-sm-6">
        <mat-form-field class="w-100">
          <mat-label>Secret</mat-label>
          <input matInput formControlName="secret">
          <mat-error *ngIf="secret.invalid && secret.touched">
            Secret is required!
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field class="w-100">
          <mat-label>Host</mat-label>
          <input matInput formControlName="host">
          <mat-error *ngIf="host.invalid && host.touched">
            Host is required!
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-sm-6">
        <mat-form-field class="w-100">
          <mat-label>Port</mat-label>
          <input matInput type="number" formControlName="port">
          <mat-error *ngIf="host.invalid && host.touched">
            Port is required!
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field class="w-100">
          <mat-label>Extension</mat-label>
          <input matInput formControlName="extension">
          <mat-error *ngIf="extension.invalid && extension.touched">
            Extension is required!
          </mat-error>
        </mat-form-field>
      </div>

    </div>
  </form>
</div>

<div mat-dialog-actions>
  <a mat-raised-button (click)="close()">Cancel</a>
  <button mat-raised-button form="ngForm"
          color="accent"
          [disabled]="form.invalid"
          (click)="save()">Save</button>
</div>
